import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "bootstrap/dist/css/bootstrap.css";
import "react-phone-input-2/lib/bootstrap.css";
import "../styles/globals.css";
import { MessageProviderWrapper } from "../context/message.context";
import UserMessage from "../components/UserMessage/UserMessage";
import { useRouter } from "next/router";
import HeadComponent from "../components/HeadComponent/HeadComponent";
import GoogleScript from "../components/_Scripts/GoogleScript";
import InitializeGoogleAnalytics from "../Tracking/GoogleTracking";
import { useEffect } from "react";
import NextNProgress from "nextjs-progressbar";
import CookieBanner from "../components/CookieBanner/CookieBanner";
import { OcrWrapper } from "../context/ocr.context";
import { BillWrapper } from "../context/bill.context";
import { CollapseWrapper } from "../context/collapse.context";
import { IPTracking } from "../Tracking/IPTracking";
import { IPTrackingWrapper } from "../context/IPTracking.context";
import { initializeUtmTracking } from "../Tracking/UtmTracking";
import TagManager from "react-gtm-module";
import ClarityScript from "../components/_Scripts/ClarityScript";
import HubSpotScript from "../components/_Scripts/HubSpotScript";
import CookieYesScript from "../components/_Scripts/CookieYesScript";
import { ComparativeWrapper } from "../context/comparative.context";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { UTMProvider } from "../context/UTMContext";
import { useSaveUTMParams } from "../hooks/useUTMParams";
import YandexScript from "../components/_Scripts/YandexScript";
import WhatsAppButton from "../components/WhatsAppButton/WhatsAppButton";
if ("object" !== "undefined") {
    // checks that we are client-side
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://app.posthog.com",
        loaded: function(posthog) {
            if ("production" === "development") posthog.debug();
        }
    });
}
function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var location = useRouter();
    var router = useRouter();
    var query = router.query;
    useSaveUTMParams();
    useEffect(function() {
        InitializeGoogleAnalytics();
        IPTracking();
        TagManager.initialize({
            gtmId: "".concat(process.env.NEXT_PUBLIC_GTM_ID)
        }); //initialize Tag Manager
    }, []);
    useEffect(function() {
        if (query) {
            initializeUtmTracking(query === null || query === void 0 ? void 0 : query.utm);
        }
    }, [
        query
    ]);
    if (location.pathname == "/sitemap.xml") {
        var headerProps = {
            title: "Sitemap.xlm",
            keywords: "Asesor\xeda energ\xe9tica, Consultor\xeda energ\xe9tica, Optimizaci\xf3n energ\xe9tica,\n      Asesoramiento el\xe9ctrico, Renovables, energ\xedas Renovables, eficiencia energ\xe9ticas,\n      consultor\xeda de software, asesoramiento de software, Comparativa de Tarifas, Comparativa de Energ\xe9tica,\n      Comparativa de luz, Comparativa de luz y gas, Comparativa de gas",
            content: "Fiva Sitemap.xml"
        };
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(NextNProgress, {}),
                /*#__PURE__*/ _jsx(GoogleScript, {}),
                /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
                /*#__PURE__*/ _jsx(Component, _object_spread({}, pageProps))
            ]
        });
    } else {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(IPTrackingWrapper, {
                children: /*#__PURE__*/ _jsx(MessageProviderWrapper, {
                    children: /*#__PURE__*/ _jsx(ComparativeWrapper, {
                        children: /*#__PURE__*/ _jsx(OcrWrapper, {
                            children: /*#__PURE__*/ _jsx(BillWrapper, {
                                children: /*#__PURE__*/ _jsxs(UTMProvider, {
                                    children: [
                                        /*#__PURE__*/ _jsx(GoogleScript, {}),
                                        /*#__PURE__*/ _jsx(ClarityScript, {}),
                                        /*#__PURE__*/ _jsx(HubSpotScript, {}),
                                        /*#__PURE__*/ _jsx(CookieYesScript, {}),
                                        /*#__PURE__*/ _jsx(YandexScript, {}),
                                        /*#__PURE__*/ _jsx(CollapseWrapper, {
                                            children: /*#__PURE__*/ _jsxs(PostHogProvider, {
                                                client: posthog,
                                                children: [
                                                    /*#__PURE__*/ _jsx(NextNProgress, {}),
                                                    /*#__PURE__*/ _jsx(Component, _object_spread({}, pageProps)),
                                                    /*#__PURE__*/ _jsx(CookieBanner, {}),
                                                    /*#__PURE__*/ _jsx(UserMessage, {}),
                                                    /*#__PURE__*/ _jsx(WhatsAppButton, {})
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        });
    }
}
export default MyApp;
